import { createStore, withProps } from '@ngneat/elf';
import { UserDto, UserString } from '@/types';
import { SelectOption } from '../../components/form-builder/form-builder.types';

export interface UserStateProps {
  response?: Partial<UserString>;
  dto?: Partial<UserDto>;
  UserEnabledSelected?: SelectOption[];
  acPiloteSelected?: SelectOption;
  selectedAcs?: SelectOption[];
  selectedComs?: SelectOption[];
  emailError?: boolean;
  passwordError?: boolean;
  usernameError?: boolean;
  firstNameError?: boolean;
  lastNameError?: boolean;
  usernameTouched?: boolean;
  firstNameTouched?: boolean;
  lastNameTouched?: boolean;
  emailTouched?: boolean;
  passwordTouched?: boolean;
  rolesTouched?: boolean;
  acsTouched?: boolean;
  acPiloteTouched?: boolean;
  comsTouched?: boolean;
  addressTouched?: boolean;
  mobileTouched?: boolean;
  fixeTouched?: boolean;
  formSubmitted?: boolean;
  confirmPasswordTouched?: boolean;
}

export const userStateInitialState: UserStateProps = {
  response: {
    id: '',
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    enabled: false,
    emailVerified: false,
    roles: [],
    acs: [],
    coms: [],
  },
  dto: {
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    enabled: false,
    emailVerified: false,
    roles: [],
    acIds: [],
    comIds: [],
    acPiloteId: undefined,
    enable: false,
  },
  UserEnabledSelected: [],
  acPiloteSelected: undefined,
  selectedAcs: [],
  selectedComs: [],
  emailError: false,
  usernameError: false,
  firstNameError: false,
  lastNameError: false,
  usernameTouched: false,
  firstNameTouched: false,
  lastNameTouched: false,
  emailTouched: false,
  passwordTouched: false,
  rolesTouched: false,
  acsTouched: false,
  acPiloteTouched: false,
  comsTouched: false,
  addressTouched: false,
  mobileTouched: false,
  fixeTouched: false,
  formSubmitted: false,
  confirmPasswordTouched: false,
};

export const userStateStore = createStore({ name: 'user-state' }, withProps<UserStateProps>(userStateInitialState));
